import { render, staticRenderFns } from "./NumerosBipados.vue?vue&type=template&id=79bd32c4&scoped=true&"
import script from "./NumerosBipados.vue?vue&type=script&lang=js&"
export * from "./NumerosBipados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79bd32c4",
  null
  
)

export default component.exports